import { createContext, useContext } from "react";

import type { Platform } from "~/providers/platform-provider";

interface PlatformContext {
  platform?: Platform;
}

export const PlatformContext = createContext<PlatformContext | undefined>(
  undefined,
);

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error("usePlatform must be used within a PlatformProvider");
  }

  return context;
};
